$(function () {
  new Swiper('.caseWrap', {
    // Optional parameters
    loop: false,
    speed: 500,
    slideWidth: 338.42,
    // spaceBetween: 33.59,
    slidesPerView: 'auto',
    // effect: 'fade',
    // allowTouchMove: false,
    // // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },
  });

  new Swiper('.fvSwiper', {
    loop: true,
    speed: 400,
    slidesPerView: 1,
    effect: 'fade',
    allowTouchMove: false,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
  });
});
